<script lang="ts" setup name="BaseCard">
const { title = '', subtitle = '' } = defineProps<{
  title?: string;
  subtitle?: string;
  noHorizontalSpacing?: boolean;
  noVerticalSpacing?: boolean;
  loading?: boolean;
  shadowless?: boolean;
}>();
</script>

<template>
  <div>
    <div
      v-if="!$slots.content"
      class="h-full rounded-md bg-white"
      :class="{ shadow: !shadowless }"
    >
      <div
        v-if="title || $slots.actions"
        class="flex items-center justify-between p-6"
      >
        <div>
          <p
            class="text-subtitle-1 text-charcoal-9"
            :class="{ 'text-loading': loading }"
          >
            {{ title }}
          </p>
          <p v-if="subtitle" class="mt-2 text-sm">
            {{ subtitle }}
          </p>
        </div>
        <slot name="actions" />
      </div>
      <div
        class="h-full"
        :class="{ 'px-6': !noHorizontalSpacing, 'pb-6': !noVerticalSpacing }"
      >
        <slot />
      </div>
    </div>
    <slot name="content" />
  </div>
</template>
